// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Icon$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as WorkSpaceContext from "../../../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as CrmUserRepoManager from "../../../../../../../library/data-source/crm-user/repo/CrmUserRepoManager.bs.js";
import * as DriverRecordsStore from "./DriverRecordsStore.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as PrimaryCard$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/primary-card/PrimaryCard.bs.js";
import * as DriverRecordAccordion from "./views/DriverRecordAccordion.bs.js";
import * as VehicleInfoViewMapper from "../../vm-mapper/driver-records/VehicleInfoViewMapper.bs.js";
import * as OwnerProfileViewMapper from "../../vm-mapper/driver-records/OwnerProfileViewMapper.bs.js";
import * as DriverRecordModalManager from "./DriverRecordModalManager.bs.js";
import * as OtherDriverInfoViewMapper from "../../vm-mapper/driver-records/OtherDriverInfoViewMapper.bs.js";
import * as SpotDriverNavbarViewMapper from "../../vm-mapper/driver-records/SpotDriverNavbarViewMapper.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as DriverRecordProfileViewMapper from "../../vm-mapper/driver-records/DriverRecordProfileViewMapper.bs.js";

function getInitialState(param) {
  return DriverRecordsStore.initialState;
}

function DriverRecordsComponent$PartnerProfile(Props) {
  var msisdn = Props.msisdn;
  var driverInfo = Props.driverInfo;
  var workspaceDispatch = Props.workspaceDispatch;
  var country = Props.country;
  var tmp;
  tmp = country.TAG === /* India */1 ? ButtonUtils$Catalyst.getDefaultButtonProps({
          TAG: /* Text */0,
          _0: "Edit"
        }, undefined, (function (param) {
            return Curry._2(workspaceDispatch.addTab, {
                        TAG: /* EditDriver */15,
                        _0: msisdn
                      }, false);
          }), undefined, Caml_option.some(React.createElement(Icon$Catalyst.EditIcon.make, {
                  fontSize: "Small"
                })), undefined, undefined, undefined, undefined, undefined) : undefined;
  return React.createElement(PrimaryCard$Catalyst.make, {
              title: {
                TAG: /* Text */0,
                _0: "Profile Info"
              },
              action: tmp,
              className: "profile-info-container",
              children: null
            }, DriverRecordProfileViewMapper.getView(driverInfo), OwnerProfileViewMapper.getView(driverInfo), VehicleInfoViewMapper.getView(driverInfo), OtherDriverInfoViewMapper.getView(driverInfo));
}

var PartnerProfile = {
  make: DriverRecordsComponent$PartnerProfile
};

function DriverRecordsComponent(Props) {
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(undefined, undefined, undefined);
  var match$2 = React.useReducer((function (state, action) {
          return DriverRecordsStore.reducer(action, state);
        }), DriverRecordsStore.initialState);
  var dispatch = match$2[1];
  var state = match$2[0];
  var match$3 = React.useState(function () {
        
      });
  var setAdminUser = match$3[1];
  var adminUser = match$3[0];
  React.useEffect((function () {
          DriverRecordsStore.loadDriver(msisdn, dispatch, country);
          DriverRecordsStore.fetchDataForCalcPartnerStatus(msisdn, dispatch, country);
          var RepoInstance = CrmUserRepoManager.getCrmUserRepo(undefined);
          ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._1(RepoInstance.fetchCurrentUser, country);
                }), (function (user) {
                  return Curry._1(setAdminUser, (function (param) {
                                return user;
                              }));
                }), (function (param) {
                  
                }));
          
        }), []);
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match$4 = React.useState(function () {
        
      });
  var driverInfo = state.driverInfo;
  var toggleModal = match$4[1];
  var driverUuid;
  switch (driverInfo.TAG | 0) {
    case /* Live */1 :
        driverUuid = driverInfo._0.driverProfile.uuid;
        break;
    case /* Loading */0 :
    case /* Error */2 :
        driverUuid = "";
        break;
    
  }
  React.useEffect((function () {
          if (driverUuid !== "") {
            DriverRecordsStore.loadSuspensionInfo(driverUuid, dispatch, country);
          }
          
        }), [driverUuid]);
  var match$5 = adminUser !== undefined ? [
      adminUser.id,
      adminUser.email
    ] : [
      0,
      ""
    ];
  return React.createElement("div", undefined, SpotDriverNavbarViewMapper.getView(msisdn, workspaceDispatch, state), React.createElement("div", {
                  className: "driver-record"
                }, React.createElement(DriverRecordsComponent$PartnerProfile, {
                      msisdn: msisdn,
                      driverInfo: driverInfo,
                      workspaceDispatch: workspaceDispatch,
                      country: country
                    }), React.createElement(DriverRecordAccordion.make, {
                      msisdn: msisdn,
                      driverUuid: driverUuid,
                      adminId: match$5[0],
                      adminEmail: match$5[1],
                      driverInfo: driverInfo,
                      tickets: state.tickets,
                      orders: state.orders,
                      suspensionInfo: state.suspensionInfo,
                      weeklyEarnings: state.weeklyEarnings,
                      walletInfo: state.walletInfo,
                      incentives: state.incentives,
                      terminationInfo: state.terminationInfo,
                      partnerDocument: state.partnerDocument,
                      helperServiceabilityInfo: state.helperServiceabilityInfo,
                      outStationServiceabilityInfo: state.outStationServiceabilityInfo,
                      premiumPartnerReport: state.premiumPartnerReport,
                      helperLabourServiceability: state.helperLabourServiceability,
                      rentalServiceability: state.rentalServiceabilityInfo,
                      toggleModal: toggleModal,
                      dispatch: dispatch
                    }), DriverRecordModalManager.getModalManager(match$4[0], toggleModal, dispatch, match$1[1], country), match$1[0]));
}

var make = DriverRecordsComponent;

export {
  getInitialState ,
  PartnerProfile ,
  make ,
  
}
/* react Not a pure module */
